import { create } from 'zustand';
import {
  ArticlePublishType,
  type ArticlePublishTypes,
} from '~/features/knowledge/article/interfaces';

interface ArticleFilterState {
  filter: ArticlePublishTypes;
  setFilter: (filter: ArticlePublishTypes) => void;
}

export const useArticleFilterStore = create<ArticleFilterState>((set) => ({
  filter: ArticlePublishType.Personal,
  setFilter: (filter) => set({ filter }),
}));
